import { DATA_SPLIT_SIGN, EMPTY_STRING, FIRST_ELEMENT } from '@constants';

import { nullableNumberToString } from './nullableNumberToString';

export const getRegularChartDataForTable = <T>(inputData: Array<T>): { headers: string[]; data: string[] } => {
  const headers = Object.keys(inputData[FIRST_ELEMENT] ?? {});

  const data = inputData.map((record) => {
    const temp = Object.keys(record ?? {}).reduce((acc, key) => {
      if (acc) {
        acc += DATA_SPLIT_SIGN;
      }
      const v = record[key as keyof T];
      if (typeof v === 'string') {
        acc += v;
      } else if (typeof v === 'number') {
        acc += nullableNumberToString(v);
      }

      return acc;
    }, EMPTY_STRING);

    return temp;
  });

  return { headers, data };
};
